import { render, staticRenderFns } from "./ModalConfirmedLowScoring.vue?vue&type=template&id=21b5cd3b&scoped=true"
import script from "./ModalConfirmedLowScoring.vue?vue&type=script&lang=js"
export * from "./ModalConfirmedLowScoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b5cd3b",
  null
  
)

export default component.exports